import forIn from "lodash/fp/forIn";
import isNil from "lodash/fp/isNil";

class Controller {
  constructor($mdDialog, $injector, ride) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.Events = $injector.get("Events");
    this.ride = ride;
    this.Company = $injector.get("Company");
    this.Contractor = $injector.get("Contractor");
    this.rideCity = ride.city.value;
    this.vendorTypes = ["company", "contractor"];

    this.updateVendorEvent = this.Events.getUpdateEvent("updateVendor");
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.confirmEvent = this.Events.getUpdateEvent("confirmEvent");

    this.vendorInfo = {};
  }

  $onInit() {
    this.Events.on(this.confirmEvent, this.confirm.bind(this));

    if (!isNil(this.ride.captain) && isNil(this.ride.captain._id)) {
      this.noReasons = true;
      this.vendorInfo.reason = null;
    }
  }

  confirm() {
    const noCapForIn = forIn.convert({ cap: false });
    const selected = {};
    noCapForIn((value, key) => {
      selected[key] = (value && value._id) || value;
    })(this.vendorInfo);

    this.$mdDialog.hide({ ...selected });
    this.clearFields();
  }

  close() {
    this.$mdDialog.cancel();
  }

  clearFields() {
    this.vendorInfo.type = null;
    this.vendorInfo.vendor = null;
    this.vendorInfo.reason = null;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/ride/vendorInfo/vendorInfo.controller.js